import React from "react";
import GaugeChart from "react-gauge-chart";

const RANGES = [
  { name: '0-49,99%', min: 0, max: 49.99, color: '#FF0000' },
  { name: '50-74,99%', min: 50, max: 74.99, color: '#FFA500' },
  { name: '75-89,99%', min: 75, max: 89.99, color: '#FFFF00' },
  { name: '90-95,99%', min: 90, max: 95.99, color: '#90EE90' },
  { name: '96-100%', min: 96, max: 100, color: '#008000' }
];

// Proporciones reales basadas en los rangos
const ARC_LENGTHS = [0.50, 0.25, 0.15, 0.06, 0.04];

const MaturityChart = ({ data, permits }) => {
  const canShowData = permits.isSuperuser ||
    (permits.hasAnyRole && permits.canEvaluationRead);

  const complianceLevel = data?.compliance_level ?? 0;
  const totalProgress = complianceLevel / 100;

  const colors = canShowData
    ? RANGES.map(range => range.color)
    : RANGES.map(() => '#CCCCCC');

  const labels = RANGES.map(item => item.name);

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "10px",
      width: "100%",
      maxWidth: "500px",
      margin: "0 auto",
      opacity: canShowData ? 1 : 0.6,
      cursor: canShowData ? 'default' : 'not-allowed'
    }}>
      <div style={{ width: "100%", height: "220px" }}>
        <GaugeChart
          id="compliance-chart"
          nrOfLevels={5}
          arcsLength={ARC_LENGTHS}
          colors={colors}
          percent={totalProgress}
          arcPadding={0.02}
          arcWidth={0.2}
          cornerRadius={3}
          needleColor="#345243"
          needleBaseColor="#666"
          textColor="#000000"
          animate={false}
          formatTextValue={() => `${complianceLevel.toFixed(2)}%`}
        />
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "10px",
          width: "100%",
          fontSize: "12px",
        }}
      >
        {RANGES.map((item, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              margin: "2px 0",
            }}
          >
            <div
              style={{
                width: "12px",
                height: "12px",
                backgroundColor: canShowData ? item.color : '#CCCCCC',
                marginRight: "6px",
                flexShrink: 0,
              }}
            ></div>
            <span style={{ whiteSpace: "nowrap" }}>{labels[index]}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MaturityChart;